export default __webpack_public_path__ + "static/media/mm.067b2113.svg";